module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Medium-WebXL.7c5adcc.woff";